import { Box, Typography } from "@mui/material";

export const ToolboxLabel = () => (
  <Typography variant="h6" sx={{ padding: (theme) => theme.spacing(0, 0, 0, 2) }} color="secondary">
    MOHAnet{" "}
    <Box component="span" sx={{ color: (theme) => theme.palette.text.primary }}>
      Toolbox
    </Box>
  </Typography>
);
